module.exports = __webpack_public_path__ + "img/video.1f42fa9f.svg";